import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  return <footer className="bg-white py-12 border-t border-gray-100" data-id="element-16">
      <div className="container mx-auto px-4 md:px-6" data-id="element-17">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-18">
          <div className="mb-6 md:mb-0" data-id="element-19">
            <Link to="/" className="text-black font-light text-xl tracking-widest" data-id="element-20">
              LIENOV
            </Link>
            <p className="mt-2 text-xs text-gray-500 max-w-xs" data-id="element-21">
              Lienov Solutions LLC
              <br data-id="element-22" />
              19390 Collins Avenue, Unit 1009
              <br data-id="element-23" />
              Sunny Isles Beach, FL 33160
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-24">
            <div data-id="element-25">
              <h3 className="text-xs font-medium mb-4 tracking-wider" data-id="element-26">Legal</h3>
              <ul className="space-y-2" data-id="element-27">
                <li data-id="element-28">
                  <Link to="/privacy-policy" className="text-xs text-gray-500 hover:text-black transition-colors" data-id="element-29">
                    Privacy Policy
                  </Link>
                </li>
                <li data-id="element-30">
                  <Link to="/terms-of-service" className="text-xs text-gray-500 hover:text-black transition-colors" data-id="element-31">
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>
            <div data-id="element-32">
              <h3 className="text-xs font-medium mb-4 tracking-wider" data-id="element-33">
                Contact
              </h3>
              <ul className="space-y-2" data-id="element-34">
                <li className="text-xs text-gray-500" data-id="element-35">
                  <a href="mailto:nikitalienov@gmail.com" className="hover:text-black transition-colors" data-id="element-36">
                    nikitalienov@gmail.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-gray-100" data-id="element-37">
          <p className="text-xs text-gray-400 text-center" data-id="element-38">
            © {new Date().getFullYear()} Lienov Solutions LLC. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;